// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Profile_gallery__2UwIo","image":"Profile_image__2EWoB","bio":"Profile_bio__2eYNA","Profile":"Profile_Profile__3j4Bg"};